import React from "react";
import Slider from "react-slick";
import _ from "lodash";

const CallOut = ({ banners }) => {
  const settings = {
    accessibility: false,
    draggable: false,
    swipe: false,
    arrows: false,
    dots: false,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplaySpeed: 5000,
    autoplay: true,
  };

  // Message will be hidden at 12:00:00am on the day AFTER the expiration date
  // Expiration dates should be formatted as yyyy/mm/dd, not yyyy-mm-dd due to how
  //   Javascript interprets the timezone
  const standardBannerMsg =
    "has provided notice of an update to its 340B Contract Pharmacy policy.";
  const customMessages = [
    // {
    //   key: "unique_key",
    //   text: "Banner text goes here.",
    //   expires: "yyyy/mm/dd",
    // },
    {
      key: "beacon",
      text: "Manufacturers subject to IPAY 2026 and IPAY 2027 have provided notice of an update to their 340B policy.",
      expires: "2026/10/31",
    },
  ];

  const getButtonText = (key) => {
    if (key === "beacon") {
      return "Learn More @ Beacon";
    } else {
      return "Learn More";
    }
  };

  const getButtonLink = (key) => {
    if (key === "beacon") {
      // Default link for manufacturers launching on Beacon
      // return "https://beaconchannelmanagement.com";

      // Specific link for the 02-Oct-2026 announcement
      return "https://cm.beaconchannelmanagement.com/pages/resources";
    } else {
      return "/resources";
    }
  };

  const activeMessages = _.filter(customMessages.concat(banners), (message) => {
    if (message.expires === null) {
      return true;
    } else {
      const today = new Date();
      const expirationDate = new Date(message.expires);
      // Advance one day; banner is valid through end of expiration date
      expirationDate.setDate(expirationDate.getDate() + 1);
      return expirationDate >= today;
    }
  });

  const renderMessages = () => {
    return _.map(activeMessages, (message) => {
      return (
        <div key={message.key}>
          <div className="callout">
            <div className="callout__indicator" />
            <div className="callout__message">{message.text}</div>
            <div className="callout__action">
              <a href={getButtonLink(message.key)}>
                <div className="btn btn--tiny btn--white color-blue">
                  {getButtonText(message.key)}
                </div>
              </a>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="animated delay slow-1 fadeInDown">
      <Slider {...settings}>{renderMessages()}</Slider>
    </div>
  );
};

export default CallOut;
